<template>
    <div>
        <div :class="isMobile ? 'contBoxB' : 'contBox'">
            <div class="clearfix">
                <span class="fl mr5" :class="isMobile ? 'ml10' : ''">
                    当前位置:
                </span>
                <el-breadcrumb
                    class="fl"
                    style="margin-top: 4px;font-size: 15px;"
                    separator-class="el-icon-arrow-right"
                >
                    <el-breadcrumb-item :to="{ path: '/' }">
                        首页
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>会员风采展示</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div
                :class="isMobile ? 'partyBoxB' : 'partyBox'"
                style="background-color: transparent;"
            >
                <el-empty
                    v-if="swiperList.length == 0"
                    description="暂无数据"
                ></el-empty>
                <div v-else :class="isMobile ? 'flex flex-col gap-5 mx-2' : 'grid grid-cols-4 gap-5'">
                    <div
                        v-for="item of swiperList"
                        :key="item.RowGuid"
                        @click="gotoDetail(item)"
                        class="bg-white rounded-md overflow-hidden cursor-pointer shadow-2xs"
                    >
                        <img
                            :src="item.img"
                            style="width: 100%;height: 180px;"
                        />
                        <div style="padding: 4px 12px 12px;">
                            <p>{{ item.dwname }}</p>
                            <p class="overh2 c66 mt5">{{ item.dwjianjie }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "ServiceList",
    data() {
        return {
            swiperList: [],
        };
    },
    methods: {
        getMemberInfo() {
            this.Request({
                url: "/api/NewsData/GetNewsimg",
                method: "get",
                data:{
                    order: 'asc',
                }
            }).then((data) => {
                this.swiperList = data.Data;
            });
        },
        gotoDetail(item) {
            if (!item.url) {
                return
            }
            const url = item.url.match(/id=([^&]+)/)
            this.$router.push({
                path: '/service/info',
                query: {
                    id: url[1],
                    type: 9106104
                }
            })
        },
    },
    created() {
        this.getMemberInfo();
    },
});
</script>

<style scoped></style>
